/*
  Shared interaction states.

  The patient base skews older, so keyboard focus is drawn as a thick, offset
  outline in the brand blue rather than a hairline ring, and every clickable
  surface gets a hover state — color alone at low contrast is not enough to
  tell someone what they are about to press.
*/

export const focusRing =
  "focus-visible:outline-3 focus-visible:outline-solid focus-visible:outline-offset-2 focus-visible:outline-focus";

/* For elements flush against a container edge, where an offset ring would clip. */
export const focusRingInset =
  "focus-visible:outline-3 focus-visible:outline-solid focus-visible:-outline-offset-3 focus-visible:outline-focus";

/* Text fields read better with the border itself changing color, plus a soft halo. */
export const focusField = "focus:border-focus focus:ring-4 focus:ring-focus/25 focus:outline-none";

export const interactive = `cursor-pointer transition-colors duration-150 ${focusRing}`;

/* Inline links inside prose: underlined (never color-only) with a hover shift. */
export const textLink = `rounded-sm underline underline-offset-4 transition-colors hover:text-accent ${focusRing}`;

/* Compact "show more / show less" control: a pill, not an underlined link. */
export const pillToggle = `inline-flex min-h-11 cursor-pointer items-center gap-2 rounded-full border border-line bg-surface px-4 py-2 font-semibold text-content-secondary transition-colors hover:border-focus hover:bg-surface-hover hover:text-accent ${focusRing}`;
